export type MaxInteractions = number | null;

export const MIN_INTERVIEW_INTERACTIONS = 3;
export const INTERVIEW_PRESENTATION_INTERACTIONS = 1;
export const MIN_INTERVIEW_TOTAL_INTERACTIONS =
  MIN_INTERVIEW_INTERACTIONS + INTERVIEW_PRESENTATION_INTERACTIONS;

export const normalizeMaxInteractions = (
  value: unknown
): MaxInteractions => {
  return typeof value === 'number' && Number.isInteger(value) && value > 0
    ? value
    : null;
};

export const ensureMinimumInteractions = (
  maxInteractions: MaxInteractions,
  minimumInteractions: number
): MaxInteractions => {
  if (maxInteractions === null) {
    return null;
  }

  return Math.max(maxInteractions, minimumInteractions);
};

export class AvatarInteractionLimitSession {
  private completedInteractions = 0;
  private interactionInFlight = false;

  constructor(private readonly maxInteractions: MaxInteractions) {}

  canStart(): boolean {
    return (
      !this.interactionInFlight &&
      (this.maxInteractions === null ||
        this.completedInteractions < this.maxInteractions)
    );
  }

  start(): boolean {
    if (!this.canStart()) {
      return false;
    }

    this.interactionInFlight = true;
    return true;
  }

  complete(): boolean {
    if (!this.interactionInFlight) {
      return false;
    }

    this.interactionInFlight = false;
    this.completedInteractions += 1;
    return true;
  }

  cancel(): void {
    this.interactionInFlight = false;
  }

  reset(): void {
    this.completedInteractions = 0;
    this.interactionInFlight = false;
  }

  get count(): number {
    return this.completedInteractions;
  }

  get reachedLimit(): boolean {
    return (
      this.maxInteractions !== null &&
      this.completedInteractions >= this.maxInteractions
    );
  }
}
